import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';

import { Observable, Subscription } from 'rxjs';

import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment-timezone';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, AbstractControl } from '@angular/forms';


import { EntranceExitEvent } from '../firestore-models/entrance-exit-event';
import { EntranceExitEntry } from '../firestore-models/entrance-exit-entry';
import { Exhibit } from '../firestore-models/exhibit';
import { ProjectLanguage } from '../firestore-models/project-language';
import { ApiEntranceExitEntry } from '../api-client-module';
import { ApiSetEntranceExitEntriesRequest } from '../api-client-module'
 
import { ApiClientService } from '../api-client.service';
import { ConfigurationService } from '../configuration.service';
import { SpinnerService } from '../services/spinner.service';
import { AppConst } from '../app-const';

import { EntranceExitEntryDialogComponent } from './entrance-exit-entry-dialog/entrance-exit-entry-dialog.component';
import { MessageDialogComponent } from '../common/message-dialog/message-dialog.component';
import { SelectEntranceExitEntryDialogComponent } from './select-entrance-exit-entry-dialog/select-entrance-exit-entry-dialog.component';
import { EntranceExitTransitDialogComponent } from './entrance-exit-transit-dialog/entrance-exit-transit-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-entrance-exit-entry',
  templateUrl: './entrance-exit-entry.component.html',
  styleUrls: ['./entrance-exit-entry.component.css'],
  standalone: false,
})
export class EntranceExitEntryComponent implements OnInit, OnDestroy {

  // コレクション
  private entranceExitEventsCollection!: AngularFirestoreCollection<EntranceExitEvent>;
  entranceExitEventsObservable!: Observable<EntranceExitEvent[]>;
  entranceExitEventsSubscribe!: Subscription;
  private entranceExitEntriesCollection!: AngularFirestoreCollection<EntranceExitEntry>;
  entranceExitEntriesObservable!: Observable<EntranceExitEntry[]>;
  entranceExitEntriesSubscribe!: Subscription;
  private exhibitsCollection!: AngularFirestoreCollection<Exhibit>;
  exhibitsObservable!: Observable<Exhibit[]>;
  exhibitsSubscribe!: Subscription;
  exhibits: Exhibit[] = [];

  //各入退場管理エントリー情報に紐付くプロジェクトID
  projectId: string;
  //各入退場管理エントリー情報に紐付くプロジェクトの言語情報
  projectLanguages!: Array<ProjectLanguage>;

  //入退場管理エントリー情報テーブル
  // displayedColumns: string[] = ['position', 'edit', 'select', 'event_name', 'open_period', 'entry_period', 'entry_no', 'company_name', 'name', 'email_address', 'mail_send_status', 'preview', 'transit', 'created'];
  displayedColumns: string[] = ['position', 'edit', 'select', 'event_name', 'entry_no', 'company_name', 'name', 'email_address', 'mail_send_status', 'preview', 'transit', 'created'];
  dataSource = new MatTableDataSource<EntranceExitEntry>();
  selection = new SelectionModel<EntranceExitEntry>(true, []);

  protected ATTR_SEARCH_WORD_PREFIX: string = 'reservationFacilityAttributes';

  attrCollectionName = AppConst.FIRESTORE_RESERVATION_FACILITY_ATTR;

  entranceExitEvents!: Array<EntranceExitEvent>;

  searchFilter: any = {};

  searchParameter = {
    entrance_exit_event_id: null,
    entry_no: null,
    limit: 15,
    index: 0,
    doc: null,
    prev_doc: null,
    next_doc: null,
    next: true,
  } as any;
  isProcessing = false;

  editForm: UntypedFormGroup;
  get pagesize(): AbstractControl { return this.editForm.get('pagesize')!; }


  // @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;


  constructor(
    private router: Router,
    public dialog: MatDialog,
    private angularFirestore: AngularFirestore,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
    private configurationService: ConfigurationService,
    private formBuilder: UntypedFormBuilder,
    private translate: TranslateService
  ) {
    this.projectId = this.configurationService.getProjectId();
    moment.tz.setDefault('Asia/Tokyo');

    this.editForm = this.formBuilder.group({
      pagesize  : new UntypedFormControl({value: '15',  disabled: false}, []),
    });

  }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    // this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.setCustomFilter();
    // 入退場管理イベント取得
    this.entranceExitEventsCollection = this.angularFirestore.collection<EntranceExitEvent>(
      AppConst.FIRESTORE_ENTRANCE_EXIT_EVENTS, ref => ref.where('project_id', '==', this.projectId));
    this.entranceExitEventsObservable = this.entranceExitEventsCollection.valueChanges({ idField: 'id' });
    this.entranceExitEventsSubscribe = this.entranceExitEventsObservable.subscribe(entranceExitEvents => {
      this.entranceExitEvents = entranceExitEvents.sort((a, b) => {
        if (a.open_start_date.seconds > b.open_start_date.seconds ) {
          return -1;
        }
        if (a.open_start_date.seconds < b.open_start_date.seconds ) {
          return 1;
        }
        return 0;
      });

      // エントリー情報取得
      this.getEntries();
    });

    // 展示情報取得
    this.exhibitsCollection = this.angularFirestore.collection<Exhibit>(
      AppConst.FIRESTORE_EXHIBITS, ref => ref.where('project_id', '==', this.projectId));
    this.exhibitsObservable = this.exhibitsCollection.valueChanges({ idField: 'id' });
    this.exhibitsSubscribe = this.exhibitsObservable.subscribe(exhibits => {
      this.exhibits = exhibits;
    });

  }

  ngOnDestroy(): void {
    this.entranceExitEventsSubscribe.unsubscribe();
    this.entranceExitEntriesSubscribe.unsubscribe();
    this.exhibitsSubscribe.unsubscribe();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() :
    this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?: EntranceExitEntry): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'}`;
  }

  // 編集ダイアログ
  openEditDialog(entry: EntranceExitEntry): void {
    const birthday: any = entry!.birthday ? new Date(entry!.birthday.seconds * 1000) : null;
    const created: any = entry!.created ? new Date(entry!.created.seconds * 1000) : null;
    const updated: any = entry!.updated ? new Date(entry!.updated.seconds * 1000) : null;
    let apiEntry: ApiEntranceExitEntry = {
      id: entry.id,
      project_id: entry.project_id,
      facility_id: entry.facility_id,
      entrance_exit_event_id: entry.entrance_exit_event_id,
      uid: entry.uid,
      lang: entry.lang,
      entry_no: entry.entry_no,
      email_address: entry.email_address,
      company_name: entry.company_name,
      department: entry.department,
      job_title: entry.job_title,
      surname_chinese: entry.surname_chinese,
      name_chinese: entry.name_chinese,
      family_name: entry.family_name,
      first_name: entry.first_name,
      birthday: birthday,
      gender: entry.gender,
      postal_code: entry.postal_code,
      prefecture: entry.prefecture,
      municipalities: entry.municipalities,
      street_address: entry.street_address,
      name_and_number_building: entry.name_and_number_building,
      mobile_phone_number: entry.mobile_phone_number,
      mail_send_status: entry.mail_send_status,
      answer: entry.answer,
      preview: entry.preview,
      user_site_url: entry.user_site_url,
      enabled: entry.enabled,
      created: created,
      updated: updated,
    };
    let curEvent = null;
    for (const event of this.entranceExitEvents) {
      if (event.id === entry.entrance_exit_event_id) {
        curEvent = event;
      }
    }
    const dialogRef = this.dialog.open(EntranceExitEntryDialogComponent, {
      width: '85%',
      disableClose: true,
      data: { change_type: AppConst.DATA_CHANGE_TYPE_UPDATE, entry: apiEntry, event: curEvent }
    });
  }

  //削除
  deleteData(): void{
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: '420px',
      height: '180px',
      disableClose: true,
      data: { message: this.translate.instant('選択されたデータを削除します。よろしいですか？') }
    });

    dialogRef.afterClosed().subscribe(result => {
      let selectedEntries: Array<ApiEntranceExitEntry> = new Array<ApiEntranceExitEntry>();
      for (const row of this.dataSource.data) {
        const birthday: any = row.birthday ? new Date(row.birthday.seconds * 1000) : null;
        const created: any = row!.created ? new Date(row!.created.seconds * 1000) : null;
        const updated: any = row!.updated ? new Date(row!.updated.seconds * 1000) : null;
        if (this.selection.isSelected(row)) {
          const selectedEntry: ApiEntranceExitEntry = {
            id: row.id,
            project_id: row.project_id,
            facility_id: row.facility_id,
            entrance_exit_event_id: row.entrance_exit_event_id,
            uid: row.uid,
            lang: row.lang,
            entry_no: row.entry_no,
            email_address: row.email_address,
            company_name: row.company_name,
            department: row.department,
            job_title: row.job_title,
            surname_chinese: row.surname_chinese,
            name_chinese: row.name_chinese,
            family_name: row.family_name,
            first_name: row.first_name,
            birthday: birthday,
            gender: row.gender,
            postal_code: row.postal_code,
            prefecture: row.prefecture,
            municipalities: row.municipalities,
            street_address: row.street_address,
            name_and_number_building: row.name_and_number_building,
            mobile_phone_number: row.mobile_phone_number,
            mail_send_status: row.mail_send_status,
            answer: row.answer,
            preview: row.preview,
            user_site_url: row.user_site_url,
            enabled: row.enabled,
            created: created,
            updated: updated
          };
          selectedEntries.push(selectedEntry);
        }
      }
      if (!!result) {
        let request: ApiSetEntranceExitEntriesRequest = {
          access_token: '',
          change_type: AppConst.DATA_CHANGE_TYPE_DELETE,
          entries: selectedEntries
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setEntranceExitEntries(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('削除しました。'));
            } else {
              this.toastr.error(this.translate.instant('削除できませんでした。'));
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('削除できませんでした。'));
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
            this.selection.clear();
          }
        );
      }
    });
  }

  openTransitDialog(entry: EntranceExitEntry) : void {
    let curEvent = null;
    for (const event of this.entranceExitEvents) {
      if (event.id === entry.entrance_exit_event_id) {
        curEvent = event;
      }
    }
    const dialogRef = this.dialog.open(EntranceExitTransitDialogComponent, {
      width: '85%',
      disableClose: true,
      data: { entry: entry, event: curEvent, exhibits: this.exhibits }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }
    const compare = (a: number | string | boolean, b: number | string | boolean, isAsc: boolean) => {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'event_name':
          return compare(this.getEventName(a), this.getEventName(b), isAsc);
        case 'open_period':
          return compare(this.getOpenPeriod(a), this.getOpenPeriod(b), isAsc);
        case 'entry_period':
          return compare(this.getEntryPeriod(a), this.getEntryPeriod(b), isAsc);
        case 'entry_no':
          return compare(a.entry_no, b.entry_no, isAsc);
        case 'company_name':
          return compare(a.company_name, b.company_name, isAsc);
        case 'department':
          return compare(a.department, b.department, isAsc);
        case 'name':
          return compare(a.family_name, b.family_name, isAsc);
        case 'email_address':
          return compare(a.email_address, b.email_address, isAsc);
        case 'mail_status':
          return compare(a.mail_send_status, b.mail_send_status, isAsc);
        case 'preview':
          return compare(a.preview, b.preview, isAsc);
        case 'created':
          return compare(a.created.toMillis(), b.created.toMillis(), isAsc);
        case 'updated':
          return compare(a.updated.toMillis(), b.updated.toMillis(), isAsc);
        default:
          return 0;
      }
    });
  }

  setCustomFilter() {
    // NOTE: AND検索
    this.dataSource.filterPredicate = (data: any, filter: any) => {
      let matchCount = 0;
      let keys = Object.keys(filter);
      for (const key of keys) {
        if (!filter[key]) {
          // フィルタに値がない場合は全抽出
          matchCount++;
        } else {
          if (data[key].trim().toLowerCase().indexOf(filter[key]) !== -1) {
            matchCount++;
          }
        }
      }
      return (keys.length === matchCount);
    };
  }

  addFilterValue(docs: Array<any>) :Array<any> {
    for (const doc of docs) {
      let filterValue = '';
      let preview = '';
      if (doc.preview === false) {
        preview = this.translate.instant('本番');
      } else if (doc.preview === true) {
        preview = this.translate.instant('プレ');
      }

      filterValue +=  doc.email_address + ' ' + doc.family_name + ' ' + doc.first_name + ' ' + preview;
      doc['filterValue'] = filterValue;
    }
    return docs;
  }

  applyFilter(event: Event) {
    this.selection.clear();
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchFilter['filterValue'] = filterValue.trim().toLowerCase();
    this.dataSource.filter = this.searchFilter;
  }

  openSearch(): void {
    const dialogRef = this.dialog.open(SelectEntranceExitEntryDialogComponent, {
      width: '640px',
      disableClose: true,
      data: this.searchParameter
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        console.log(result);
        this.searchParameter.entrance_exit_event_id = result.entrance_exit_event_id;
        this.searchParameter.entry_no = result.entry_no;
        this.searchParameter.index = 0;
        this.searchParameter.doc = null;
        this.searchParameter.next = true;
        this.getEntries();
      }
    });
  }

  async getEntries(): Promise<void> {
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;    

    if (!!this.entranceExitEntriesSubscribe) {
      this.entranceExitEntriesSubscribe.unsubscribe();
    }
    this.entranceExitEntriesCollection = this.angularFirestore.collection<EntranceExitEntry>(AppConst.FIRESTORE_ENTRANCE_EXIT_ENTRIES, ref => 
    {
      let query: any = ref;
      query = query.where('project_id', '==', this.projectId);
      if (!!this.searchParameter.entrance_exit_event_id) { 
        query = query.where('entrance_exit_event_id', '==', this.searchParameter.entrance_exit_event_id);
      };
      if (!!this.searchParameter.entry_no) { 
        query = query.where('entry_no', '==', this.searchParameter.entry_no);
      };
      if (!this.searchParameter.entry_no) {
        query = query.orderBy('created', 'desc');
      }
      if (!!this.searchParameter.doc) {
        if (this.searchParameter.next) {
          query = query.startAfter(this.searchParameter.doc);
        } else {
          query = query.endBefore(this.searchParameter.doc);
        }
      }
      if (this.searchParameter.next) {
        query = query.limit(this.searchParameter.limit + 1);
      } else {
        query = query.limitToLast(this.searchParameter.limit + 1);
      }
      return query;
    });


    this.entranceExitEntriesObservable = this.entranceExitEntriesCollection.valueChanges({ idField: 'id' });
    this.entranceExitEntriesSubscribe = this.entranceExitEntriesObservable.subscribe(async entries => {

      // 次回検索開始位置を保持
      this.searchParameter.next_doc = null;
      if (entries.length > 0) {
        if (this.searchParameter.next) {
          const subPrev = this.angularFirestore.collection(AppConst.FIRESTORE_ENTRANCE_EXIT_ENTRIES).doc(entries[0].id).get().subscribe(doc => {
            subPrev.unsubscribe();
            this.searchParameter.prev_doc = doc;
          });
          if (entries.length > this.searchParameter.limit) {
            const subNext = this.angularFirestore.collection(AppConst.FIRESTORE_ENTRANCE_EXIT_ENTRIES).doc(entries[this.searchParameter.limit - 1].id).get().subscribe(doc => {
              subNext.unsubscribe();
              this.searchParameter.next_doc = doc;
            });
          }
        } else {
          if (entries.length > this.searchParameter.limit) {
            const subPrev = this.angularFirestore.collection(AppConst.FIRESTORE_ENTRANCE_EXIT_ENTRIES).doc(entries[1].id).get().subscribe(doc => {
              subPrev.unsubscribe();
              this.searchParameter.prev_doc = doc;
            });
          } else {
            this.searchParameter.prev_doc = null;
          }
          const subNext = this.angularFirestore.collection(AppConst.FIRESTORE_ENTRANCE_EXIT_ENTRIES).doc(entries[entries.length - 1].id).get().subscribe(doc => {
            subNext.unsubscribe();
            this.searchParameter.next_doc = doc;
          });
        }
        entries = entries.slice(0, this.searchParameter.limit); 
      } else {
        this.searchParameter.index = 0;
        this.searchParameter.doc = null;
        this.searchParameter.prev_doc = null;
      }
      this.dataSource.data = this.addFilterValue(entries);

      this.isProcessing = false;    
    });
  
  }

  getEventName(entry: EntranceExitEntry): string {
    let eventName = '';
    for (const event of this.entranceExitEvents) {
      if (entry.entrance_exit_event_id === event.id) {
        eventName = event.names[0].name;
        break;
      }
    }
    return eventName;
  }

  getOpenPeriod(entry: EntranceExitEntry): string {
    let openPeriod = '';
    for (const event of this.entranceExitEvents) {
      if (entry.entrance_exit_event_id === event.id) {
        openPeriod = moment(event.open_start_date.toDate()).format('YYYY/MM/DD') + ' - ' + moment(event.open_end_date.toDate()).format('YYYY/MM/DD');
        break;
      }
    }
    return openPeriod;
  }

  getEntryPeriod(entry: EntranceExitEntry): string {
    let entryPeriod = '';
    for (const event of this.entranceExitEvents) {
      if (entry.entrance_exit_event_id === event.id) {
        entryPeriod = moment(event.entry_start_date.toDate()).format('YYYY/MM/DD') + ' - ' + moment(event.entry_end_date.toDate()).format('YYYY/MM/DD');
        break;
      }
    }
    return entryPeriod;
  }

  // ページサイズ変更
  onPageSizeChange(event: any) {
    this.searchParameter.limit = Number(this.pagesize.value)
    this.searchParameter.index = 0;
    this.searchParameter.doc = null;
    this.searchParameter.next = true;
    this.getEntries();
  }

  // 前へ
  onPrevClick() {
    this.searchParameter.index--;
    this.searchParameter.doc = this.searchParameter.prev_doc;
    this.searchParameter.next = false;
    this.getEntries();
  }

  // 次へ
  onNextClick() {
    this.searchParameter.index++;
    this.searchParameter.doc = this.searchParameter.next_doc;
    this.searchParameter.next = true;
    this.getEntries();
  }}
